import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import CodeService from 'services/system/CodeService'

export const initialState = {
  loading: false,
  message: '',
  list: {},
}

export const selectCodesList = createAsyncThunk('code/select-codes-list', async (data, { rejectWithValue }) => {
  const response = await CodeService.selectCodesList()

  if (response) {
    return response
  } else {
    return rejectWithValue(response.message)
  }
})

export const codeSlice = createSlice({
  name: 'code',
  initialState,
  extraReducers: builder => {
    builder
      .addCase(selectCodesList.pending, state => {
        state.loading = true
      })
      .addCase(selectCodesList.fulfilled, (state, action) => {
        state.loading = false
        state.list = action.payload
      })
      .addCase(selectCodesList.rejected, (state, action) => {
        state.message = action.payload
        state.loading = false
      })
  },
})

export default codeSlice.reducer
